import React, { useState, useEffect, useRef } from "react";
import { FaArrowUp } from "react-icons/fa";

const MultiActionScrollButton = ({ scrollContainerId }) => {
  const [showButton, setShowButton] = useState(false);
  const pressActionRef = useRef({
    longPressTimer: null,
    clickTimer: null,
    clicks: 0,
  });

  useEffect(() => {
    const scrollContainer = document.getElementById(scrollContainerId);
    if (!scrollContainer) return;

    const checkScrollTop = () => {
      if (!showButton && scrollContainer.scrollTop > 400) {
        setShowButton(true);
      } else if (showButton && scrollContainer.scrollTop <= 400) {
        setShowButton(false);
      }
    };

    scrollContainer.addEventListener("scroll", checkScrollTop);
    return () => scrollContainer.removeEventListener("scroll", checkScrollTop);
  }, [showButton, scrollContainerId]);

  const handleScrollPageUp = () => {
    const scrollContainer = document.getElementById(scrollContainerId);
    if (scrollContainer) {
      scrollContainer.scrollBy({
        top: -scrollContainer.clientHeight,
        behavior: "smooth",
      });
    }
  };

  const handleScrollToTop = () => {
    const scrollContainer = document.getElementById(scrollContainerId);
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePressStart = () => {
    pressActionRef.current.longPressTimer = setTimeout(() => {
      handleScrollToTop();
      pressActionRef.current.longPressTimer = null; // Mark as fired
    }, 700); // 700ms for long press
  };

  const handleClick = () => {
    if (pressActionRef.current.longPressTimer) {
      clearTimeout(pressActionRef.current.longPressTimer);
      pressActionRef.current.longPressTimer = null;
    } else {
      // If long press fired, do nothing on click
      return;
    }

    pressActionRef.current.clicks += 1;

    if (pressActionRef.current.clicks === 1) {
      pressActionRef.current.clickTimer = setTimeout(() => {
        handleScrollPageUp();
        pressActionRef.current.clicks = 0; // Reset
      }, 250); // Wait for a potential double click
    } else if (pressActionRef.current.clicks === 2) {
      clearTimeout(pressActionRef.current.clickTimer);
      handleScrollToTop();
      pressActionRef.current.clicks = 0; // Reset
    }
  };

  if (!showButton) {
    return null;
  }

  return (
    <button
      onMouseDown={handlePressStart}
      onClick={handleClick}
      onMouseUp={() => clearTimeout(pressActionRef.current.longPressTimer)}
      onMouseLeave={() => clearTimeout(pressActionRef.current.longPressTimer)}
      onContextMenu={(e) => e.preventDefault()}
      className="fixed bottom-6 right-6 bg-red-600 text-white p-4 rounded-full shadow-lg hover:bg-red-700 transition-opacity duration-300 transform hover:scale-110"
      style={{ opacity: showButton ? 1 : 0 }}
    >
      <FaArrowUp />
    </button>
  );
};

export default MultiActionScrollButton;
